<template>
  <div class="main">
    <div class="b-nav">
      <img src="../assets/imgs/spec/icon_home.png" alt="">
      <div class="location">您当前所在的位置:</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>侨联概况</el-breadcrumb-item>
        <el-breadcrumb-item>{{childContent}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <column-nav :fl-details="contentDetail" :now-column="nowColumn" @b-content="getChildContent" />
      <base-article :title="childContent" class="spec-article" :article="article" v-if="articles.length>0"/>
    </div>
  </div>
</template>

<script>
  import ColumnNav from "../components/common/ColumnNav";
  import BaseArticle from "../components/common/BaseArticle";
  import { overviewInfo } from '../api/index'
  export default {
    name: "Overview",
    components: {
      ColumnNav,
      BaseArticle
    },
    data() {
      return {
        contentDetail: ['侨联简介', '侨联章程', '机构设置', '本届领导', '历届委员', '联系方式'],
        childContent: '侨联简介',
        nowColumn: 1,
        articles: [],
        article: {}
      }
    },
    methods: {
      getChildContent(data) {
        this.childContent = this.contentDetail[data - 1]
        this.article = this.articles[data - 1]
        // console.log(this.article);
      },
      getData() {
        overviewInfo().then(res => {
          this.articles = res.data
          this.article = res.data[this.nowColumn - 1]
        })
      }
    },
    mounted() {
      this.$store.commit('changeNum', 2)
    },
    created() {
      window.scroll(0,0)
      this.getData()
      if (this.$route.params.label) {
        this.nowColumn = this.$route.params.label
      }
      this.childContent = this.contentDetail[this.nowColumn - 1]
    }
  }
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 50px auto 0;
  .b-nav {
    width: 670px;
    height: 16px;
    display: flex;
    align-items: center;
    .location {
      font-family: 'SourceHanSansCN-Regular';
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      /*line-height: 16px;*/
      letter-spacing: 0;
      color: #656565;
      margin-left: 7px;
    }
    .el-breadcrumb {
      margin-left: 10px;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 16px;
      letter-spacing: 0;
      color: #656565;
      ::v-deep .is-link {
        font-weight: normal;
        color: #656565;
      }
      ::v-deep .is-link:hover {
        color: #d43e42;
        border-bottom: solid 1px #d43e42;
      }
    }
    img {
      width: 15px;
      height: 16px;
    }
  }
  .content {
    width: 1000px;
    min-height: 600px;
    margin: 30px auto 0;
    display: flex;
    justify-content: space-between;
    .spec-article {
      width: 800px;
    }
  }
}
</style>
